const vitals = {
  bloodPressure: 'Blood Pressure',
  bloodOxygenSaturation: 'Blood Oxygen Saturation',
  bloodGlucose: 'Blood Glucose',
  chooseVitalType: 'Choose Vital Type',
  dateTime: 'Date & Time',
  vitalType: 'Vital Type',   
  value: 'Value',   
  note: 'Note',   
}

export default vitals